import { Forbidden } from 'fejl'
import { type ClientAssignmentApi } from '@/features/iam/api/iam-api'
import { Id } from '@/infra/id'

/**
 * A client's assignment to their advisors.
 */
export interface ClientAssignment {
  /**
   * The public IDs of the advisors assigned to the client.
   */
  advisorUserPublicIds: Id[]
}

export class ClientAssignmentStore {
  constructor(private readonly _api: ClientAssignmentApi) {}

  /**
   * Fetches the client's assignment, or `null` when the current member may not
   * see it.
   */
  async fetchClientAssignment(
    workspaceId: Id,
    clientUserPublicId: Id,
    signal?: AbortSignal,
  ): Promise<ClientAssignment | null> {
    const resource = await this._api
      .get(Id.assert(workspaceId), Id.assert(clientUserPublicId), signal)
      .catch(Forbidden.ignore(null))

    return resource
      ? { advisorUserPublicIds: resource.advisor_user_public_ids.map(Id) }
      : null
  }
}
